import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'
import { toDateFormatComma } from '~/shared/utils/date'

export default class DigitalLectureVideoCard extends BaseModel {
  static override constructorName = 'DigitalLectureVideoCard'

  id: number = 0
  'category_id': number = 0
  'created_at': string = ''
  'date_publication': string = ''
  description: string = ''
  'is_published': boolean = false
  'likes_count': number = 0
  name: string = ''
  preview: string = ''
  'preview_description': string = ''
  'short_description': string = ''
  slug: string = ''
  'updated_at': string = ''
  'video_file': string = ''
  'video_link': string = ''
  time: string = ''
  'views_count': number = 0

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }

    this.preview = toCroppedImage(this.preview)

    if (this.date_publication) {
      this.date_publication = toDateFormatComma(this.date_publication)
    }
  }
}

registerModel(DigitalLectureVideoCard)
